// extracted by mini-css-extract-plugin
module.exports = {"button":"aa1254b386--button--O41Oz"};